module.exports = __webpack_public_path__ + "static/media/012.4cf3d004.jpg";